import { useRef } from "react";
import { Box, Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import EditableTableContainer, { EditableTableContainerApi } from "@arelia-components/editable-table/EditableTableContainer";
import { formatCurrency } from "@arelia-utils/helpers/formatCurrency";
import { API_ROUTE, columnConfig } from './constants';
import { RevenueOverview } from "../../../types/earnings";
import { ChangeCardStatus } from "../../../components/ui-atoms/ChangeCardStatus";
import calcDifference from "../../../utils/helpers/calcDifference";
import { FormEditActions } from "@arelia-components/form/FormEditActions";

export interface SimpleDialogProps {
  open: boolean;
  title: string;
  data: RevenueOverview;
  selectedPeriod?: string;
  headerComponent?: JSX.Element | undefined;

  onClose: () => void;
  onTotalsRefresh: () => void;
}

export function TipsEditDialog({ open, title, data, selectedPeriod, headerComponent, onClose, onTotalsRefresh }: SimpleDialogProps) {
  const apiRef = useRef<EditableTableContainerApi>();

  const onAddRow = () => apiRef.current?.addRow();
  const onSave = () => apiRef.current?.save();

  return (
    <Dialog onClose={onClose} open={open} maxWidth={'lg'}>
      <DialogTitle width={750} sx={{ marginBottom: '20px', display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ display: 'flex', gap: "6px", alignItems: "center" }}>
          {title}
          {headerComponent ?? <></>}
        </Box>
        <FormEditActions handleReset={onClose} handleSubmit={onSave} />
      </DialogTitle>
      <DialogContent>
        <Typography variant="h2" sx={{ textAlign: 'center' }}>{formatCurrency(data.total)} Total</Typography>
        <ChangeCardStatus change={calcDifference(data.totalThisPeriod, data.totalPrevPeriod)} timespan={selectedPeriod} sx={{ justifyContent: 'center' }}/>
        <Box sx={{ marginTop: '42px' }}>
          <EditableTableContainer
            apiRef={apiRef}
            columnConfig={columnConfig}
            onTotalsRefresh={onTotalsRefresh}
            apiRoute={API_ROUTE}
            onAddRow={onAddRow}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}